import { render, staticRenderFns } from "./page-aside.vue?vue&type=template&id=1648d0df&lang=pug&"
import script from "./page-aside.vue?vue&type=script&lang=js&"
export * from "./page-aside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports